import React from 'react';
import Icon from '../../../../components/AppIcon';

const ProgressIndicator = ({ currentStep, totalSteps }) => {
    const steps = [
        { number: 1, label: 'Country & Language' },
        { number: 2, label: 'Personal Details' },
        { number: 3, label: 'Verification' },
    ];

    return (
        <div className="mb-8">
            <div className="flex items-center justify-between max-w-sm mx-auto">
                {steps.map((step, index) => (
                    <React.Fragment key={step.number}>
                        <div className="flex flex-col items-center">
                            <div
                                className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-all ${step.number === currentStep
                                        ? 'bg-primary text-white'
                                        : step.number < currentStep
                                            ? 'bg-green-500 text-white'
                                            : 'bg-accent-200 text-accent-600'
                                    }`}
                            >
                                {step.number < currentStep ? (
                                    <Icon name="check" className="w-4 h-4" />
                                ) : (
                                    step.number
                                )}
                            </div>
                            <span
                                className={`text-xs mt-2 text-center max-w-20 ${step.number === currentStep
                                        ? 'text-primary font-medium'
                                        : step.number < currentStep
                                            ? 'text-green-600'
                                            : 'text-accent-500'
                                    }`}
                            >
                                {step.label}
                            </span>
                        </div>
                        {index < steps.length - 1 && (
                            <div
                                className={`flex-1 h-0.5 mx-2 transition-all ${step.number < currentStep
                                        ? 'bg-green-500'
                                        : 'bg-accent-200'
                                    }`}
                            />
                        )}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default ProgressIndicator; 